import { memo } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

const Footer = memo(({ selectionCount, onClearSelection }) => {
    const navigate = useNavigate()
    const { id: campaignId } = useParams()

    if (selectionCount === 0) {
        return null
    }

    const handleAddToCampaign = () => {
        // Navigate to the add to campaign page
        navigate(`/campaigns/media-buying/${campaignId}/creatives/add-to-campaign`)
    }

    return (
        <div className="tw:absolute tw:bottom-0 tw:left-0 tw:right-0 tw:z-10">
            <div className="tw:bg-[#071727] tw:p-5 tw:border-t">
                <div className="tw:flex tw:justify-end">
                    <button
                        className="tw:bg-[#2450BF] tw:text-white tw:h-9 tw:border-none tw:px-3 tw:py-3 tw:rounded-md tw:!text-sm tw:font-normal tw:cursor-pointer tw:flex tw:items-center tw:gap-2 tw:shadow-lg"
                        onClick={handleAddToCampaign}
                    >
                        Add Selected to Campaign ({selectionCount})
                    </button>
                </div>
            </div>
        </div>
    )
})

Footer.displayName = 'Footer'

export default Footer
